import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Pause = createReactComponent("Pause", ["svg", defaultAttributes, [["rect", {
  x: "6",
  y: "4",
  width: "4",
  height: "16",
  key: "18bzn1"
}], ["rect", {
  x: "14",
  y: "4",
  width: "4",
  height: "16",
  key: "xo49r8"
}]]]);
export default Pause;